import React, { useState } from 'react';
import { TermsOfServiceModal } from '../legal/TermsOfServiceModal';
import { PrivacyPolicyModal } from '../legal/PrivacyPolicyModal';
import { VEXATIOUS_LABEL, VEXATIOUS_DETAIL } from '../../lib/config/vexatiousClauses';

interface ProfileLegalConsentProps {
  termsAccepted: boolean;
  vexatiousAccepted: boolean;
  onTermsChange: (checked: boolean) => void;
  onVexatiousChange: (checked: boolean) => void;
  error?: string | null;
}

const checkboxClass =
  'mt-0.5 h-4 w-4 shrink-0 rounded border-[rgba(55,53,47,0.3)] text-[#2383E2] focus:ring-[#2383E2] cursor-pointer';

/**
 * Consensi legali mostrati nello step Profilo SOLO quando l'utente non li ha
 * mai accettati: succede col signup social partito dalla pagina di login o da
 * Google One Tap, dove le spunte di /register non vengono mai mostrate.
 * Stesso copy e stile delle checkbox dell'entry di registrazione.
 */
export function ProfileLegalConsent({
  termsAccepted,
  vexatiousAccepted,
  onTermsChange,
  onVexatiousChange,
  error,
}: ProfileLegalConsentProps) {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  return (
    <div className="space-y-2.5 pt-4 border-t border-[rgba(55,53,47,0.09)]">
      <label className="flex items-start gap-2.5 cursor-pointer">
        <input
          type="checkbox"
          checked={termsAccepted}
          onChange={(e) => onTermsChange(e.target.checked)}
          className={checkboxClass}
        />
        <span className="text-xs text-[#787774] leading-relaxed">
          Ho letto e accetto i{' '}
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); setShowTermsModal(true); }}
            className="text-[#2383E2] hover:underline"
          >
            Termini e Condizioni
          </button>{' '}
          e la{' '}
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); setShowPrivacyModal(true); }}
            className="text-[#2383E2] hover:underline"
          >
            Privacy Policy
          </button>
        </span>
      </label>

      <div>
        <label className="flex items-start gap-2.5 cursor-pointer">
          <input
            type="checkbox"
            checked={vexatiousAccepted}
            onChange={(e) => onVexatiousChange(e.target.checked)}
            className={checkboxClass}
          />
          <span className="text-xs text-[#787774] leading-relaxed">
            {VEXATIOUS_LABEL}{' '}
            (<button
              type="button"
              onClick={(e) => { e.preventDefault(); setShowDetail(!showDetail); }}
              className="text-[#2383E2] hover:underline"
            >
              {showDetail ? 'nascondi dettaglio' : 'vedi dettaglio'}
            </button>)
          </span>
        </label>
        {showDetail && (
          <p className="mt-1.5 ml-[26px] text-[11px] text-[#9B9A97] leading-relaxed">
            {VEXATIOUS_DETAIL}
          </p>
        )}
      </div>

      {error && <p className="text-xs text-red-500">{error}</p>}

      <TermsOfServiceModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} />
      <PrivacyPolicyModal isOpen={showPrivacyModal} onClose={() => setShowPrivacyModal(false)} />
    </div>
  );
}
